var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.39093 15.6938L3.9424 18.2531L3.92319 15.3L0.39093 15.6938Z",
    fill: "#70164A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9702 8.92236V34.2913C29.9702 35.2353 29.2052 36 28.2616 36H5.65105C4.70746 36 3.94238 35.2353 3.94238 34.2913V1.70901C3.94238 0.765073 4.70746 0 5.65105 0H20.426L29.9702 8.92236Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9682 7.16479H0.708821C0.317346 7.16479 0 7.48215 0 7.87362V15.0604C0 15.4519 0.317346 15.7692 0.708821 15.7692H16.9682C17.3597 15.7692 17.677 15.4519 17.677 15.0604V7.87362C17.677 7.48215 17.3597 7.16479 16.9682 7.16479Z",
    fill: "#C93281"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6217 14.0801V13.5453L6.0357 9.83239H3.84319V9.08374H7.1358V9.61859L4.71412 13.3315H7.15117V14.0801H3.6217Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07568 14.0801V9.08374H8.96198V14.0801H8.07568Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2301 14.0801V9.08374H11.8039C12.0788 9.08374 12.3349 9.10924 12.5718 9.16025C12.8086 9.21125 13.0137 9.29789 13.1866 9.41981C13.3596 9.54209 13.4947 9.70139 13.5915 9.89737C13.6883 10.0934 13.7368 10.3365 13.7368 10.6268C13.7368 10.9017 13.6883 11.1414 13.5915 11.3451C13.4947 11.5487 13.3609 11.7182 13.1905 11.853C13.0196 11.9879 12.8188 12.0874 12.5868 12.151C12.3552 12.2146 12.1043 12.2464 11.8343 12.2464H11.116V14.0798H10.2297L10.2301 14.0801ZM11.1164 11.5362H11.7658C12.4991 11.5362 12.8659 11.2333 12.8659 10.6272C12.8659 10.3114 12.7705 10.0937 12.5795 9.97388C12.3884 9.8544 12.1071 9.79431 11.7354 9.79431H11.1167V11.5362H11.1164Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9702 8.92236V9.18646H21.4674C20.8183 9.18646 20.2919 8.66 20.2919 8.01056V0H20.426L29.9702 8.92236Z",
    fill: "#E6E7E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 18.5474H8.75433V19.9615H25.1587V18.5474Z",
    fill: "#E6E7E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1586 21.8059H8.75427V23.2201H25.1586V21.8059Z",
    fill: "#E6E7E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1586 25.0647H8.75427V26.4789H25.1586V25.0647Z",
    fill: "#E6E7E8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1586 28.3235H8.75427V29.7376H25.1586V28.3235Z",
    fill: "#E6E7E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1586 31.582H8.75427V32.9962H25.1586V31.582Z",
    fill: "#E6E7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipMessage);
export default __webpack_public_path__ + "static/media/zip_message.cdf16a5453efad68fb1d476c7edc3036.svg";
export { ForwardRef as ReactComponent };